<template>
  <div class="hello">
    <Menu></Menu>
    <div class="class">
      <!-- <div class="page-top-wrap"> -->
      <div class="top wrap clear">
        <h2 class="bold  float-left">클래스 게시판</h2>
        <br />
        <p class="bold">{{ classinfo.classname }}</p>
        <p class="font-14 mt-10">
          수업 문의, 학습자료, 과제 제출을 할 수 있는 게시판입니다.
        </p>
        <!-- <div class="pt-10">
                    <select>
                        <option>카테고리 전체</option>
                    </select>
                    <select class="ml-10">
                        <option>전체</option>
                    </select>
                </div> -->
      </div>
      <!-- </div> -->

      <div class="page-top-wrap-notice pb-20">
        <div class="notice-wrap">
          <div class="notice-title">
            <div>
              <span class="writer">{{ info.kname }}</span>
              <span class="gubun btn-point ml-10" v-if="info.gubun == 'MEMBER'"
                >학생</span
              >
              <span class="gubun btn-point ml-10" v-if="info.gubun == 'TUTOR'"
                >강사님</span
              >
              <span class="gubun btn-point ml-10" v-if="info.gubun == 'HQ'"
                >매니저</span
              >
              <span class="line ml-10 mr-10">|</span>
              <span class="comment"
                ><img src="../assets/img/comment_icon.png" />&nbsp;{{
                  info.cmtcnt
                }}</span
              >
              <span class="createdate">{{ info.createdate }}</span>
            </div>
            <h1>[{{ info.category_text }}] {{ info.title }}</h1>
          </div>
          <div class="notice-file" v-if="info.upfilenames.length > 0">
            <div v-for="(item, index) in info.upfilenames" :key="index">
              <a
                href="#"
                onclick="return false;"
                @click="download(info.upfilelinks[index])"
                ><img src="../assets/img/file-download.png" class="mr-10" />{{
                  item
                }}</a
              >
            </div>
          </div>
          <div class="notice-body">
            <div v-html="info.contents" class="pt-10">
              <!-- <span class="bold">Strong points</span>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type</p>

                        <span class="bold">Weak points</span>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type</p>

                        <span class="bold">Next action plans</span>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type</p> -->
            </div>
            <div class="notice-btn" v-if="uidx == info.writer">
              <button class="btn-ok cur-pointer" @click="doUpdate(info.b_idx)">
                수정
              </button>
              <button class="btn-del cur-pointer" @click="doDelete(info.b_idx)">
                삭제
              </button>
            </div>
          </div>
        </div>
        <div class="comment-wrap">
          <div class="comment-top">
            <p class="font-14">댓글</p>
          </div>
          <div class="comment-itmes">
            <ul>
              <li v-for="(item, index) in cmtlist" :key="index">
                <div class="item-top">
                  <div class="item-left">
                    <span class="bold com-writer">{{ item.kname }}</span>
                    <span class="com-date">{{ item.createdate }}</span>
                  </div>
                  <div class="item-right" v-if="uidx == item.writer">
                    <button
                      class="btn-ok btn-ok2 cur-pointer"
                      @click="com_update(item.contents, index)"
                    >
                      수정
                    </button>
                    <button
                      class="btn-del btn-del2 cur-pointer"
                      @click="doDeleteReply(item.cmt_idx)"
                    >
                      삭제
                    </button>
                  </div>
                </div>
                <!-- <p>{{item.contents}}</p> -->
                <p v-html="item.contents.replace(/<br \/>\n/g, '\n')"></p>
                <div class="wrap" v-if="item.is_com_update">
                  <div>
                    <textarea v-model="item.com_content"></textarea>
                  </div>
                  <div>
                    <button
                      @click="comment_update(item.cmt_idx, item.com_content)"
                    >
                      댓글수정
                    </button>
                  </div>
                </div>
              </li>
              <!-- <li class="clear">
                            <div class="clear item-top">
                                <div class="item-left">
                                    <span class="bold com-writer">Yulia</span>
                                    <span class="com-date">2020-07-01</span>
                                </div>
                                <div class="item-right">
                                    <span class="delete" >삭제</span>
                                    <span class="ml-10">수정</span>
                                </div>
                            </div>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                        </li> -->
            </ul>
            <div class="comment-add mt-10">
              <div class="wrap" style="width:90%">
                <div>
                  <textarea
                    placeholder="댓글을 입력해 주세요"
                    v-model="ccontents"
                  ></textarea>
                </div>
                <div>
                  <button @click="comment_add()">글쓰기</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="notice-bottom-btn clear">
          <button class="list btn-base-white float-left" @click="goList()">
            목록
          </button>
          <button
            class="list btn-base-white float-right ml-10"
            v-if="info.next_sn != null"
            @click="nextBtn(info.next_sn)"
          >
            <span><img src="../assets/img/arrow-top.png"/></span
            >&nbsp;&nbsp;다음글
          </button>
          <button
            class="list btn-base-white float-right"
            v-if="info.prev_sn != null"
            @click="prevBtn(info.prev_sn)"
          >
            <span><img src="../assets/img/arrow-down.png"/></span
            >&nbsp;&nbsp;이전글
          </button>
        </div>
      </div>
    </div>

    <!-- 푸터 -->
    <div class="footer clear">
      Copyright© <span class="bold">CARROT</span> Global Inc. All rights
      reserved.<br />
    </div>
  </div>
</template>

<script>
import Menu from "../components/inc_menu.vue";
import router from "@/router";
export default {
  name: "NoticeView",
  components: {
    Menu,
  },
  props: {
    msg: String,
  },
  data: () => ({
    b_idx: "",
    bcode: "",
    classid: "",
    ccontents: "",
    uidx: localStorage.getItem("uidx"),
    info: {},
    cmtlist: [],
    is_com_update: false,
    com_content: "",
    classinfo: {},
  }),
  created() {
    if (location.hostname == "stagest.carrotenglish.net") {
      this.$store.commit("changeHost", "https://stagestapi.carrotenglish.net");
    } else if (location.hostname == "st.carrotenglish.net") {
      this.$store.commit("changeHost", "https://stapi.carrotenglish.net");
    } else if (location.hostname == "student.carrotenglish.net") {
      this.$store.commit("changeHost", "https://stapi.carrotenglish.net");
    } else if (location.hostname == "m.carrotenglish.net") {
      this.$store.commit("changeHost", "https://stapi.carrotenglish.net");
    } else if (location.href.includes("how")) {
      if (location.href.includes("stage")) {
        this.$store.commit(
          "changeHost",
          "https://stagestapi.carrotenglish.net"
        );
      } else {
        this.$store.commit("changeHost", "https://stapi.carrotenglish.net");
      }
    } else {
      this.$store.commit("changeHost", "https://stapi.carrotenglish.net");
    }
    this.$store.commit("loginCheck");
  },
  mounted() {
    //    this.doc_del_rendar();
    this.b_idx = this.$route.query.b_idx;
    this.bcode = this.$route.query.bcode;
    this.classid = this.$route.query.classid;
    this.initPage();
    this.getClassInfo();
  },
  methods: {
    getClassInfo: function() {
      var me = this;
      var params = {
        uidx: localStorage.getItem("uidx"),
      };
      this.axios
        .get(
          this.$store.state.host + "/rest/mobile/classinfo_new/" + me.classid,
          {
            params: params,
          }
        )
        .then(function(res) {
          if (res.data.err == 0) {
            me.classinfo = res.data;
            console.log(me.classinfo);
          } else {
            alert(res.data.err_msg);
          }
          me.is_loader = false;
        });
    },
    comment_update: function(cmt_idx, content) {
      // console.log(cmt_idx);
      // console.log(this.com_content);
      // var me = this;
      if (content == "") {
        alert("댓글 내용을 입력해주세요.");
        return false;
      }
      var params = {
        cmt_id: cmt_idx,
        com_content: content,
        uidx: localStorage.getItem("uidx"),
      };
      // console.log(params);
      if (confirm("댓글을 수정하시겠습니까?") == true) {
        this.axios
          .post(
            this.$store.state.host + "/rest/mobile/classboarCommentUpdate",
            params
          )
          .then(function(res) {
            // console.log(res.data);
            if (res.data.err == 0) {
              alert("수정되었습니다");
              location.reload();
            } else {
              alert("댓글 수정 실패");
            }
          });
      }
    },
    com_update: function(contents, index) {
      this.cmtlist[index].is_com_update = true;
      this.cmtlist[index].com_content = contents.replace(/<br \/>\n/g, "\n");

      // this.is_com_update = true;
      // this.com_content = contents;
    },
    doDeleteReply: function(cmt_id) {
      console.log("delete reply comment");

      var params = {
        cmt_id: cmt_id,
        tmr: Date.now(),
        uidx: localStorage.getItem("uidx"),
        accessKey: localStorage.getItem("accessKey"),
      };
      if (confirm("댓글을 삭제하시겠습니까?") == true) {
        var me = this;
        console.log(me);

        this.axios
          .get(this.$store.state.host + "/rest/mobile/classboardCommentDel", {
            params: params,
          })
          .then(function(res) {
            if (res.data.err == 0) {
              alert("댓글이 삭제 되었습니다.");
              // me.getData(me.vinfo.b_idx, 'V');
              location.reload();
            } else {
              alert(res.data.err_msg);
              if (res.data.err == 213) router.push("/login");
            }
          });
      }
    },
    comment_add() {
      var params = {
        b_idx: this.b_idx,
        contents: this.ccontents,
        uidx: localStorage.getItem("uidx"),
        tmr: Date.now(),
        accessKey: localStorage.getItem("accessKey"),
      };
      if (confirm("댓글을 작성을 하시겠습니까?") == true) {
        // var me = this;
        this.axios
          .post(
            this.$store.state.host + "/rest/mobile/classboardCommentAdd",
            params
          )
          .then(function(res) {
            if (res.data.err == 0) {
              // me.ccontents = "";
              // me.getData(me.vinfo.b_idx, 'V');
              alert("댓글이 등록되었습니다.");
              location.reload();
            } else {
              alert(res.data.err_msg);
              if (res.data.err == 213) router.push("/login");
            }
          });
      }
    },
    nextBtn(next_sn) {
      location.href =
        "/noticeview?b_idx=" +
        next_sn +
        "&bcode=" +
        this.bcode +
        "&classid=" +
        this.classid;
    },
    prevBtn(prev_sn) {
      location.href =
        "/noticeview?b_idx=" +
        prev_sn +
        "&bcode=" +
        this.bcode +
        "&classid=" +
        this.classid;
    },
    initPage() {
      var me = this;
      console.log(me.b_idx);
      var params = {
        b_idx: this.b_idx,
        bcode: this.bcode,
      };
      this.axios
        .get(this.$store.state.host + "/rest/mobile/classboardview", {
          params: params,
        })
        .then(function(res) {
          //    console.log(res.data);
          if (res.data.err == 0) {
            me.info = res.data.info;
            me.cmtlist = res.data.cmtList.list;

            me.info.upfilelinks = me.info.upfilelinks.filter(function(item) {
              return item !== null && item !== undefined && item !== "";
            });
            me.info.upfilenames = me.info.upfilenames.filter(function(item) {
              return item !== null && item !== undefined && item !== "";
            });
            me.info.upfilesizes = me.info.upfilesizes.filter(function(item) {
              return item !== null && item !== undefined && item !== "";
            });

            // me.info.contents = me.info.contents.replace('src="','src="https://itm.carrotenglish.net/')
            me.info.contents = me.replaceAll(
              me.info.contents,
              'src="',
              'src="https://itm.carrotenglish.net/'
            );

            console.log(me.info);
          } else {
            alert(res.data.err_msg);
          }
        });
    },
    doDelete(b_idx) {
      if (confirm("정말로 게시글을 삭제하시겠습니까?") == true) {
        var me = this;
        var params = {
          uidx: localStorage.getItem("uidx"),
          accessKey: localStorage.getItem("accessKey"),
        };
        this.axios
          .get(this.$store.state.host + "/rest/mobile/classboarddel/" + b_idx, {
            params: params,
          })
          .then(function(res) {
            if (res.data.err == 0) {
              alert("삭제 되었습니다.");
              location.href = "/noticelist?classid=" + me.classid;
              // me.doSearch();
              // me.chkWriteForm(0);
              // me.chkViewForm(0);
            } else {
              alert(res.data.err_msg);
              if (res.data.err == 213) router.push("/login");
            }
          });
      }
    },
    doUpdate(b_idx) {
      var me = this;
      location.href =
        "/noticemodfiy?b_idx=" +
        b_idx +
        "&bcode=" +
        me.bcode +
        "&classid=" +
        me.classid;
    },
    goList() {
      location.href = "/noticelist?classid=" + this.classid;
    },
    download(url) {
      var host = "";
      if (location.hostname == "stagest.carrotenglish.net") {
        host = "https://stagestapi.carrotenglish.net/";
      } else if (location.hostname == "st.carrotenglish.net") {
        host = "https://stapi.carrotenglish.net/";
      } else if (location.hostname == "student.carrotenglish.net") {
        host = "https://stapi.carrotenglish.net/";
      } else if (location.hostname == "m.carrotenglish.net") {
        host = "https://stapi.carrotenglish.net/";
      } else {
        host = "https//hq.test.co.kr";
      }
      location.href = host + "download?filepath=" + url + "&tp=MEMBER";
    },
    replaceAll(str, searchStr, replaceStr) {
      return str.split(searchStr).join(replaceStr);
    },
  },
  //
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap");

$point-color: #53caff;
$purple: #6974ff;
$gray: #b7b7b7;
$border-color: #e9e9e9;
$back-gray: #f5f5f5;

// 결석
$absent: #ff4068;
// 출석
$attend: #53caff;
// 휴강
$cancel: #ffb055;
// 예정
$scheduled: #e1e1e1;
// 공결
$reasons: #2feecd;

// 게시글 수정 버튼
.btn-ok {
  background-color: #ffffff;
  padding: 5px 10px;
  border: 1px solid #53caff;
  border-radius: 4px;
  font-size: 16px;
  color: #53caff;
}
// 댓글 수정 버튼
.btn-ok2 {
  font-size: 13px;
}
// 게시글 삭제 버튼
.btn-del {
  background-color: #ffffff;
  padding: 5px 10px;
  border: 1px solid #ff5353;
  border-radius: 4px;
  font-size: 16px;
  color: #ff5353;
}
// 댓글 삭제 버튼
.btn-del2 {
  font-size: 13px;
}

.class {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 10px;

  .floating-write {
    position: fixed;
    right: 0;
    cursor: pointer;
    bottom: 0;
  }
  .top {
    border-bottom: 10px solid #f5f5f5;
    padding-bottom: 17px;
    padding-top: 70px;
    background: url("../assets/img/top-bg.png") no-repeat right -80px;
    background-size: 300px;
    position: relative;

    .my-reason {
      position: absolute;
      right: 0;
      bottom: 15%;
    }

    p {
      font-size: 16px;
      letter-spacing: 0px;
      color: #000000;
      opacity: 1;
      margin-top: 20px;
    }

    div {
      select {
        border: 1px solid var(--unnamed-color-53caff);
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid #53caff;
        border-radius: 4px;
        opacity: 1;
        color: #53caff;
      }
    }
  }
  .wrap {
    width: 100%;
    max-width: 700px;
  }

  .page-top {
    border-bottom: 1px solid #e9e9e9;

    .review-top {
      div {
        background: #f5f5f5 0% 0% no-repeat padding-box;
        border: 1px solid #e9e9e9;
        border-radius: 10px;
        opacity: 1;
        width: 95%;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 19px;
        padding-bottom: 19px;

        p {
          float: left;
          text-align: center;

          &:first-child {
            font-size: 14px;
            letter-spacing: 0px;
            color: #b7b7b7;
            opacity: 1;
          }

          &:last-child {
            font-size: 14px;
            letter-spacing: 0px;
            color: #000000;
            opacity: 1;
          }
        }
      }
    }
  }

  .page-top-wrap-notice {
    width: 90%;
    margin: 0 auto;
    max-width: 700px;
    .none-notice {
      display: table;
      min-height: 300px;
      width: 100%;

      p {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        color: var(--unnamed-color-b7b7b7);
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0px;
        color: #b7b7b7;
        opacity: 1;
      }
    }

    .notice-wrap {
      padding-top: 20px;

      .notice-title {
        width: 100%;
        padding-bottom: 20px;

        div {
          width: 90%;
          margin: 0 auto;

          .writer {
            font-size: 14px;
            letter-spacing: 0px;
            color: #b7b7b7;
            opacity: 1;
          }

          .line {
            color: #b7b7b7;
          }

          .comment {
            color: #b7b7b7;
            font-size: 12px;
            letter-spacing: 0px;
            color: #b7b7b7;
            opacity: 1;
            img {
              width: 15px;
            }
          }

          .createdate {
            float: right;
            font-size: 11px;
            letter-spacing: 0px;
            color: #b7b7b7;
            opacity: 1;
          }
        }

        h1 {
          text-align: left;
          font-size: 18px;
          letter-spacing: 0px;
          color: #000000;
          opacity: 1;
          font-weight: bold;
          margin-top: 5px;
          margin-left: 20px;
        }

        border-bottom: 1px dashed #e9e9e9;
      }

      .notice-file {
        width: 100%;
        border-bottom: 1px dashed #e9e9e9;
        padding-top: 5px;
        padding-bottom: 5px;

        div {
          width: 90%;
          margin: 0 auto;

          a {
            font-size: 14px;
            letter-spacing: 0px;
            color: #53caff;
            opacity: 1;
          }
        }
      }

      .notice-body {
        width: 100%;

        div {
          width: 90%;
          margin: 0 auto;

          span {
            display: block;
            padding-top: 25px;
          }

          p {
            text-align: left;
            font-size: 14px;
            letter-spacing: 0px;
            color: #000000;
          }
        }

        .notice-btn {
          display: flex;
          justify-content: flex-end;
          gap: 0 10px;
        }
      }
    }

    .comment-wrap {
      margin-top: 30px;
      border-top: 10px solid #f5f5f5;
      padding-top: 10px;
      padding-bottom: 30px;
      .comment-top {
        width: 90%;
        margin: 0 auto;
        border-bottom: 2px solid #f5f5f5;
        padding-bottom: 10px;
      }
      ul {
        li {
          padding-top: 20px;
          width: 90%;
          margin: 0 auto;
          border-bottom: 1px dashed #e9e9e9;
          padding-bottom: 20px;

          .item-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .item-left {
              .com-writer {
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
              }

              .com-date {
                font-size: 11px;
                letter-spacing: 0px;
                color: #b7b7b7;
                opacity: 1;
                margin-left: 10px;
              }
            }

            .item-right {
              display: flex;
              gap: 10px;
              margin-bottom: 15px;
            }
          }

          p {
            text-align: left;
            font-size: 14px;
            letter-spacing: 0px;
            color: #000000;
            margin-bottom: 10px;
          }
        }

        &:last-child {
          border-bottom: 0px;
        }
      }
    }

    .notice-bottom-btn {
      width: 90%;
      margin: 0 auto;
      padding-top: 20px;
    }
  }
}

.footer {
  position: static;
}

textarea {
  width: 100%;
  resize: none;
  border: 1px solid #eeeeee;
  height: 100px;
}

.class {
  .page-top-wrap-notice {
    .comment-wrap {
      .comment-itmes {
        .wrap {
          display: flex;
          flex-direction: column;
          width: 100%;
          border: 1px solid #eeeeee;

          textarea {
            padding: 0;
            border: 0 none;
          }

          > div:nth-child(1) {
            padding: 5px;
            border-bottom: 1px solid #eeeeee;
          }

          > div:nth-child(2) {
            padding: 5px;
            align-self: flex-end;
            button {
              width: max-content;
              background-color: #53caff;
              font-size: 14px;
              color: #ffffff;
              padding: 5px 10px;
              border: 0 none;
              border-radius: 4px;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 414px) {
  .class {
    width: 100%;
    .top {
      background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
      background-size: 300px;
      &.wrap {
        width: 100%;
        padding-left: 5%;
        max-width: none;
      }
    }
    .page-top-wrap-notice {
      width: 100%;
    }
    .page-top-wrap {
      .wrap {
        width: 90%;
        max-width: none;
      }
    }
  }
}
</style>
